import { type } from "arktype";
import { ForceRefreshSchema } from "./force-refresh-schema";

export const BaseGetInputSchema = type("<orderBy, where>", {
  "orderBy?": "orderBy | orderBy[]",
  "where?": "where",
  cursor: "string?",
  limit: type("1 <= number.integer <= 100").default(20),
  forceRefresh: ForceRefreshSchema,
});

export const BasePaginatedSchema = type("<item>", {
  items: "item[]",
  nextCursor: "string | null",
  hasMore: "boolean",
  count: "number",
});

export type GenericPaginated<T = unknown> = ReturnType<
  typeof BasePaginatedSchema<type.cast<T>>
>["infer"];

// ts types matching the arktype schemas ^
export interface BaseGetInput<TOrderBy, TWhere> {
  limit: number;
  cursor?: string;
  orderBy?: TOrderBy | TOrderBy[];
  where?: TWhere;
  forceRefresh: boolean;
}

export interface BasePaginated<T> {
  items: T[];
  nextCursor: string | null;
  hasMore: boolean;
  count: number;
}
